import React from 'react'
import Header from '../Menpages/Header/Main'
import Footer from '../Menpages/Footer/Main'
import Bredcom from '../MenTeam/Bredcom'
import Aboutteem from '../Menteamdetails/Aboutteem'
import Years from '../Menteamdetails/Years'
import Slider from '../Menpages/GlobleSlider/Main'

function Main() {
  return (
    <>
      <div className="page-wrapper">
        <Header />
        <Bredcom title={"Home"} head={"Single Team"} sbtitle={"Single Team"} />
        <Aboutteem />
        <Years />
        <Slider />
        <Footer />
      </div>
    </>
  )
}

export default Main